var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevFeaturedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 63 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "dev-featured-icon_svg__a",
    d: "M0 60h62.222V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.334 23.889c0 13.193-10.696 23.889-23.89 23.889-13.193 0-23.888-10.696-23.888-23.89C5.556 10.697 16.25 0 29.445 0c13.193 0 23.889 10.696 23.889 23.889",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "dev-featured-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dev-featured-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#dev-featured-icon_svg__b)",
    d: "M32.222 58.889h8.89V30h-8.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.333 57.778H40V31.11h-6.667v26.667zM31.111 60h11.111V28.889h-11.11V60z",
    fill: "#020303",
    mask: "url(#dev-featured-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#dev-featured-icon_svg__b)",
    d: "M17.778 58.889h8.889V43.333h-8.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.889 57.778h6.667V44.444h-6.667v13.334zM16.667 60h11.11V42.222h-11.11V60z",
    fill: "#020303",
    mask: "url(#dev-featured-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    mask: "url(#dev-featured-icon_svg__b)",
    d: "M3.333 58.889h8.89V50h-8.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.444 57.778h6.667V51.11H4.444v6.667zM2.222 60h11.111V48.889H2.223V60z",
    fill: "#020303",
    mask: "url(#dev-featured-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8E9EA",
    mask: "url(#dev-featured-icon_svg__b)",
    d: "M46.667 58.889h8.889v-50h-8.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.778 57.778h6.666V10h-6.666v47.778zM45.556 60h11.11V7.778h-11.11V60z",
    fill: "#020303",
    mask: "url(#dev-featured-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#dev-featured-icon_svg__b)",
    d: "M0 60h62.222v-2.222H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    mask: "url(#dev-featured-icon_svg__b)",
    d: "M35.556 8.906l-13.333-.018 3.333 3.334L3.715 34.444 10 40.73l22.223-22.953 3.333 3.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.28 34.438l4.707 4.708 22.222-22.953 2.235 2.236v-8.412l-9.536-.014 2.212 2.213L5.28 34.438zm4.733 7.877L2.151 34.45l21.84-22.222-4.454-4.454 17.13.02v15.998l-4.431-4.43-22.223 22.952z",
    fill: "#020303",
    mask: "url(#dev-featured-icon_svg__b)"
  }))));
}
export default SvgDevFeaturedIcon;